import React from 'react'
import { Outlet } from 'react-router-dom'
function Mainstream() {
  return (
       <div><Outlet/></div>
  )
}
export default Mainstream